<template>
  <form autocomplete="off" v-on:submit.prevent="submit(form)" class="form">
    <div class="flex form-row">
      <div class="col-12">
        <label for="terms_accepted"></label>
        <div class="inline-block relative w-full">
          <input id="terms_accepted" type="checkbox" name="terms_accepted" class="h-6 w-6 align-middle"
                 v-model="form.terms_accepted" v-validate="'required'" data-vv-as="terms"><span class="text-black pl-2 pb-3"> I have read and agree to the Terms and Conditions and Privacy Policy</span>
        </div>
        <span v-if="errors.has('terms_accepted')">{{ errors.first('terms_accepted') }}</span>
      </div>
    </div>
    <button class="body-8 btn" :disabled="pending || errors.any()">Submit</button>
  </form>
</template>

<script>
  export default {
    name: 'AcceptTermsForm',
    props: ['pending'],

    data: function() {
      return {
        form: {
          terms_accepted: null,
        }
      }
    },

    methods: {
      submit() {
        this.$validator.validateAll().then((valid) => {
          if (valid) {
            this.$emit('submit', this.form);
          }
        });
      }
    }
  }
</script>